import type { ImplementedCopilotFeatures, CopilotSettingsStore } from 'owa-copilot-settings-store';
import { getApplicationSettings } from 'owa-application-settings';
import isCopilotFeatureEnabled from './isCopilotFeatureEnabled';
import createStoreCheckForGenericEnablement from './createStoreCheckForGenericEnablement';
import type { MailboxInfo } from 'owa-client-types';
import { isFeatureEnabled } from 'owa-feature-flags';

type ElaborateScenarios = Extract<ImplementedCopilotFeatures, 'Elaborate'>;

const isCalendarElaborateEnabled: (
    scenario: 'Elaborate',
    mailboxInfo: MailboxInfo,
    skipLanguageCheck?: boolean,
    shouldIgnoreUserPreferences?: boolean
) => boolean | undefined =
    // eslint-disable-next-line owa-custom-rules/no-side-effects -- BASELINE, DO NOT COPY-PASTE
    createStoreCheckForGenericEnablement<ElaborateScenarios, boolean>(
        'CalendarElaborate',
        isCalendarElaborateEnabledInternal
    );

export default isCalendarElaborateEnabled;

function isCalendarElaborateEnabledInternal(
    store: CopilotSettingsStore,
    _language: string,
    scenario: ElaborateScenarios,
    mailboxInfo: MailboxInfo,
    skipLanguageCheck?: boolean,
    skipGroupMailboxCheck?: boolean
): boolean {
    // Feature is not supported for Group Mailboxes
    if (!skipGroupMailboxCheck && mailboxInfo.type === 'GroupMailbox') {
        return false;
    }

    if (store.isEnabled) {
        const featureEnabled = store.featureInfo.get(scenario);
        if (featureEnabled?.isEnabled) {
            const appSettings = getApplicationSettings('Copilot', mailboxInfo);
            return (
                !!isCopilotFeatureEnabled(
                    scenario,
                    mailboxInfo,
                    skipLanguageCheck ?? appSettings.enableMultiLanguage
                ) &&
                isFeatureEnabled('time-copilot-calendar-draft-polaris') &&
                appSettings.calendarElaborateEnabled && // This is controlled through the Killswitch ECS here: https://ecs.skype.com/Substrate/OutlookWebClient/configurations/1092852
                !!featureEnabled.capabilities &&
                'calendarElaborate' in featureEnabled.capabilities &&
                featureEnabled.capabilities.calendarElaborate
            );
        }
    }
    return false;
}
